import React from 'react'
import Logo from "../../assets/images/logo.png"
import "../ErrorPage/Error.css"
const Thankyou = () => {
  return (
    <div className='page-top'>
<div className="errorPage">
<div className="errorPage_container">
<div className="d-logo">
<a href="index.html"><img src={Logo} alt="logo" width="80" /></a>



</div>

<h1>Thank You </h1>
<p>You are successfully reset your password</p>

</div>
</div>
</div>
  )
}

export default Thankyou